const middleware = {}

middleware['access'] = require('@/middleware/access.js');
middleware['access'] = middleware['access'].default || middleware['access']

middleware['no-mobile-access'] = require('@/middleware/no-mobile-access.js');
middleware['no-mobile-access'] = middleware['no-mobile-access'].default || middleware['no-mobile-access']

middleware['site'] = require('@/middleware/site.js');
middleware['site'] = middleware['site'].default || middleware['site']

export default middleware
